import React, { useState } from 'react';
interface LoginModalProps {
  isOpen: boolean;
  token: string;
  onClose: () => void;
  onLoginSuccess: () => void;
  onLoginFailure: (title: string, message: string) => void;
}

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose, onLoginSuccess, token ,onLoginFailure }) => {  
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();   
    if (password === token) {
      onLoginSuccess();
    } else {
      onLoginFailure(
        'Acceso Denegado',
        'El token es incorrecto. No tienes permiso para acceder a esta sección.'
      );
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-scrim/30 dark:bg-scrim/50 z-40 flex items-center justify-center p-4 animate-fade-in" onClick={onClose} aria-modal="true" role="dialog">
      <div className="relative bg-surface-container-high dark:bg-dark-surface-container-high rounded-3xl shadow-2xl w-full max-w-sm m-4 transform animate-scale-in" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-outline-variant dark:border-dark-outline-variant">
            <h2 className="text-xl font-medium text-on-surface dark:text-dark-on-surface">Iniciar Sesión</h2>
            <button onClick={onClose} className="text-on-surface-variant dark:text-dark-on-surface-variant hover:bg-error/10 dark:hover:bg-dark-error/10 rounded-full p-1 transition-colors" aria-label="Cerrar modal">
                <CloseIcon />
            </button>
        </div>
        <form onSubmit={handleSubmit} className="p-6 space-y-4">            
            <div>
                <label htmlFor="password"  className="block text-sm font-medium text-on-surface-variant dark:text-dark-on-surface-variant mb-1">
                    Password (Token)
                </label>
                <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="w-full bg-surface-container dark:bg-dark-surface-container border-2 border-outline dark:border-dark-outline focus:border-primary dark:focus:border-dark-primary focus:ring-0 rounded-lg p-2.5 outline-none transition-colors"
                    placeholder="password"
                />
            </div>
            <button type="submit" className="w-full mt-4 bg-primary dark:bg-dark-primary hover:shadow-lg text-on-primary dark:text-dark-on-primary font-bold py-3 px-4 rounded-full transition-shadow">
                Iniciar Sesión
            </button>
        </form>
      </div>
      <style>{`
        @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
        .animate-fade-in { animation: fade-in 0.3s ease-out forwards; }
        @keyframes scale-in { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scale-in 0.3s ease-out forwards; }
      `}</style>
    </div>
  );
};

export default LoginModal;
